import { createReducer } from "@reduxjs/toolkit";
import { resetNotificationActionCreator, showNotificationActionCreator } from "../actions/notifications";

export const notificationReducer = createReducer<string | null>(null, {
    [showNotificationActionCreator.type]: (string, action) => action.payload,
    [resetNotificationActionCreator.type]: () => null,
});
